const features = [
  {
    icon: '👥',
    title: 'Subscriber Management',
    desc: 'Manage customers, subscriptions, milk quantities, delivery schedules and subscriber details.',
    color: '#eff6ff',
  },
  {
    icon: '🔄',
    title: 'Milk Subscription Management',
    desc: 'Create and manage daily, monthly and custom milk subscriptions.',
    color: '#ecfdf5',
  },
  {
    icon: '🥛',
    title: 'Product Management',
    desc: 'Manage milk types and additional dairy products offered by the dairy.',
    color: '#fef3c7',
  },
  {
    icon: '🚚',
    title: 'Delivery Management',
    desc: 'Track daily delivery requirements and subscriber-wise quantities.',
    color: '#fce7f3',
  },
  {
    icon: '📋',
    title: 'Orders Management',
    desc: 'Manage customer orders and keep track of order status.',
    color: '#f3e8ff',
  },
  {
    icon: '✉️',
    title: 'Email Notifications',
    desc: 'Send important subscription, order and account notifications to customers through email.',
    color: '#ecfdf5',
  },
  {
    icon: '🏢',
    title: 'Multi-Tenant Management',
    desc: 'Each dairy operates independently within its own MilkFlow account.',
    color: '#eff6ff',
  },
  {
    icon: '📊',
    title: 'Reports & Dashboard',
    desc: 'Give dairy administrators clear visibility into subscribers, orders, deliveries and performance.',
    color: '#fef3c7',
  },
]

export default function FeaturesSection() {
  return (
    <section id="features" className="mf-section mf-features">
      <div className="mf-container">
        <h2 className="mf-section-title mf-reveal">Everything Your Dairy Needs to Grow</h2>
        <p className="mf-section-subtitle mf-reveal">
          A complete platform designed to simplify and streamline every aspect of your dairy operations.
        </p>

        <div className="mf-features-grid">
          {features.map((f, i) => (
            <div key={i} className="mf-feature-card mf-reveal" style={{ transitionDelay: `${i * 0.07}s` }}>
              <div className="mf-feature-icon" style={{ background: f.color }}>
                {f.icon}
              </div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
